import { useEffect, useState, useContext } from "react";
import { toast } from "react-toastify";
import { CreateDREAndBalanceYear, DeleteDREAndBalanceYear, GetAllDREAndBalanceYears, PutApproximateValueCompany } from "../../../API/AnalysisAPI";
import useCreate from "../../../Hooks/useCreate";
import useModal from "../../../Hooks/useModal";
import { IResponseProps } from "../../../Interfaces/IResponseProps";
import { IYearsProps } from "../../../Interfaces/IYearsProps";
import { SortYearDesc } from "../../../Utils/SortYear";
import ModalSelectYear from "../../Shared/ModalSelectYear";
import PaginationTabHeader from "../../Shared/PaginationTabHeader";
import CollapseUploadComponent from "../CollapseUploadComponent";
import { CompanyContext } from "../../../Contexts/CompanyContext";
import { Button, Input, Typography } from "antd";
import { CloudUploadOutlined, DeleteOutlined } from "@ant-design/icons";
import './styles.css';

interface IUploadFilesComponentProps {
    companyId: string,
    userEmail: string,
    toggleLoading: (data: boolean) => void,
    FINNCanNotView: boolean,
    defaultFinancialValue?: string,
    canNotView: boolean
}

const UploadFilesComponent = (props: IUploadFilesComponentProps) => {
    const [key, setKey] = useState<number>(0);
    const { showModal, toggleShowModal } = useModal();
    const { isCreate, toggleIsCreate } = useCreate();
    const { company, getCompany } = useContext(CompanyContext);
    const [yearsToUpload, setYearsToUpload] = useState<IYearsProps[]>([]);
    const [yearToUpload, setYearToUpload] = useState<string>("");
    const [pag, setPag] = useState<number>(0);
    const [financialValue, setFinancialValue] = useState<string>(props.defaultFinancialValue ?? "");

    const getAllYears = async () => {
        try {
            props.toggleLoading(true);
            await GetAllDREAndBalanceYears(props.companyId).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    let descOrder = SortYearDesc(resp.data);
                    setYearsToUpload(descOrder);
                }
            }).finally(() => {
                props.toggleLoading(false);
                setYearToUpload("");
            })
        } catch (error: any) {
            props.toggleLoading(false);
            toast.error(error);
        }
    }

    const createYearDREAndBalance = async () => {
        try {
            props.toggleLoading(true);
            await CreateDREAndBalanceYear(props.companyId, yearToUpload, props.userEmail).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    getAllYears();
                }
            }).finally(() => {
                props.toggleLoading(false);
                setYearToUpload("");
            });
        } catch (error: any) {
            props.toggleLoading(false);
            setYearToUpload("");
            toast.error(error);
        }
    }

    const deleteYear = async () => {
        try {
            props.toggleLoading(true);

            await DeleteDREAndBalanceYear(props.companyId, yearsToUpload[pag].id, yearsToUpload[pag].year.toString()).then((resp: IResponseProps) => {
                if (resp.statusCode == 200) {
                    setPag(0);
                    getAllYears();
                    toast.success("Ano deletado com sucesso!");
                }
            }).finally(() => {
                setYearToUpload("");
                props.toggleLoading(false);
            });
        } catch (error: any) {
            props.toggleLoading(false);
            toast.error(error);
        }
    }

    const putApproximateValue = async () => {
        try {
            if (financialValue == "") {
                return;
            }
            if (financialValue != props.defaultFinancialValue && financialValue != undefined && financialValue != null) {
                props.toggleLoading(true);

                await PutApproximateValueCompany(company.id, parseFloat(financialValue.replace(',', '.')), props.userEmail).then((resp: IResponseProps) => {
                    if (resp.statusCode == 200) {
                        getCompany(company.id);
                    }
                }).finally(() => {
                    props.toggleLoading(false);
                });
            }
        } catch (error: any) {
            props.toggleLoading(false);
            toast.error(error);
        }
    }

    useEffect(() => {
        getAllYears();
    }, []);

    useEffect(() => {
        if (yearToUpload != "" && isCreate) {
            createYearDREAndBalance();
        } else if (yearToUpload != "" && !isCreate) {
            deleteYear();
        }
    }, [yearToUpload]);

    return (
        <div>
            <ModalSelectYear
                years={yearsToUpload.map(x => x.year)}
                qtdYearsMinus={2}
                isCreate={isCreate}
                setYear={setYearToUpload}
                show={showModal}
                toggleShow={toggleShowModal}
            />
            {yearsToUpload.length > 0 ?
                <div className='pagination-tabs mt-4'>
                    <div className="buttons-group">
                        {
                            !props.FINNCanNotView && (
                                <>
                                    <Button
                                        type="primary"
                                        className="create-button"
                                        onClick={() => {
                                            toggleIsCreate(true);
                                            toggleShowModal();
                                        }}
                                    >
                                        <CloudUploadOutlined /> Criar Ano Para Upload
                                    </Button>
                                    <Button
                                        type="default"
                                        className="delete-buttons"
                                        onClick={() => {
                                            toggleIsCreate(false);
                                            toggleShowModal();
                                        }}
                                    >
                                        <DeleteOutlined /> Remover Ano
                                    </Button>
                                </>
                            )}
                    </div>

                    <PaginationTabHeader setPag={setPag} pag={pag} setKey={setKey} keyDefault={key} tabs={yearsToUpload.map(x => x.year)} />

                    <div className='pagination-tab-body p-3'>
                        <CollapseUploadComponent
                            yearId={yearsToUpload[pag].id}
                            companyId={props.companyId}
                            userEmail={props.userEmail}
                            toggleLoading={props.toggleLoading}
                            typeOfFile={0}
                            yearName={yearsToUpload[pag].year.toString()}
                            FINNCanNotView={props.FINNCanNotView}
                        />
                        <CollapseUploadComponent
                            yearId={yearsToUpload[pag].id}
                            companyId={props.companyId}
                            userEmail={props.userEmail}
                            toggleLoading={props.toggleLoading}
                            typeOfFile={1}
                            yearName={yearsToUpload[pag].year.toString()}
                            FINNCanNotView={props.FINNCanNotView}

                        />
                    </div>

                    <div className="card card-header mt-4">
                        <div className="financial-input-container">
                            <Typography.Text className="financial-label">
                                Qual o valor aproximado que a empresa pretende financiar?
                            </Typography.Text>
                            <div className="financial-input-wrapper"> 
                                <Input
                                    prefix="R$"
                                    className="financial-input"
                                    value={financialValue}
                                    onChange={(e) => setFinancialValue(e.target.value)}
                                    onBlur={putApproximateValue}
                                    placeholder="0,00"
                                    disabled={props.canNotView}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                :
                <div style={{ display: 'flex', gap: '20px', justifyContent: 'center' }}>
                    <Button
                        type="primary"
                        className="custom-button"
                        onClick={() => {
                            toggleIsCreate(true);
                            toggleShowModal();
                        }}
                    >
                        <div className="button-content">
                            <div className="icon-circle">
                                <CloudUploadOutlined style={{ fontSize: '24px' }} />
                            </div>
                            <span className="button-text">Criar Ano Para Upload</span>
                        </div>
                    </Button>
                </div>
            }
        </div>
    )
}

export default UploadFilesComponent;